<div
  class="container-fluid"
  [ngClass]="{ 'p-0': mobileMode(), 'h-100': mobileMode() }"
  style="position: relative"
  [style.background-color]="clozeTestStyleModel().siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{ 'h-100': mobileMode() }">
    <div
      class="card"
      [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
      style="min-height: 570px"
      [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '0.25rem',
        width: mobileMode() ? '' : '720px',
      }">
      <!-- mobile exercise indicator start -->
      @if (mobileMode()) {
        <onset-cloze-test-exercise-indicator
          [totalExercise]="totalExercise()"
          [cTestLogo]="cTestLogo()"
          [displayLogo]="clozeTestStyleModel().displayLogo"
          [currentExerciseNumber]="currentExcerciseNumber()">
        </onset-cloze-test-exercise-indicator>
      }
      <!-- mobile exercise indicator end -->
      <div
        class="card-body"
        [ngClass]="{ 'card-mobile': mobileMode() }"
        [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="this.clozeTestStyleModel().fontSize"
        style="overflow-y: auto">
        @if (clozeTestStyleModel().displayLogo && !mobileMode()) {
          <img class="floating-logo" [src]="cTestLogo()" alt="Logo" />
        }
        <h5 class="card-title text-center font-weight-bold" [innerHTML]="title()"></h5>
        <div [style.line-height]="lineHeight" style="padding-top: 10px">
          @for (input of inputs; track input; let i = $index) {
            <onset-cloze-test-exercise-input
              [mobileMode]="mobileMode()"
              [nr]="$any(input.id)"
              [text]="input.text"
              [isLast]="i === inputs.length - 1"
              [lastWord]="input.lastWord"
              [answer]="input.answer"
              (answerChange)="input.answer = $event">
            </onset-cloze-test-exercise-input>
          }
        </div>
        <div class="text-center" style="padding-top: 10px">
          <div class="row justify-content-around">
            <div class="col-2" style="padding-top: 6px">
              @if (!mobileMode()) {
                <div>
                  <p>
                    {{
                      lastExerciseNumber() !== undefined && lastExerciseNumber() !== null
                        ? ("GAST-ONSET-NG.EXERCISE.TEXT_FROM_TO"
                          | translate
                            : {
                                currentExerciseNumber: currentExcerciseNumber(),
                                lastExerciseNumber: lastExerciseNumber(),
                              })
                        : ("GAST-ONSET-NG.EXERCISE.TEXT_FROM"
                          | translate
                            : {
                                currentExerciseNumber: currentExcerciseNumber(),
                              })
                    }}<br />
                  </p>
                </div>
              }
            </div>
            @if (inputs && inputs.length > 0) {
              <div class="col-4" style="padding-top: 4px">
                <input
                  type="checkbox"
                  style="vertical-align: middle"
                  id="finishCheckbox"
                  name="finishCheckbox"
                  [checked]="readyCheckbox"
                  (change)="readyCheckbox = !readyCheckbox" />
                <label class="font-weight-bold" for="finishCheckbox" style="font-size: smaller; padding-left: 6px">
                  {{ "GAST-ONSET-NG.EXERCISE.DONE" | translate }}</label
                >
              </div>
            }
            <div class="col-4">
              @if (!isLastExercise()) {
                <button
                  class="btn"
                  style="font-size: smaller"
                  (click)="onNextExercise()"
                  [hidden]="!readyCheckbox"
                  [disabled]="!readyCheckbox"
                  [style.background-color]="cTestButtonColor()">
                  {{ "GAST-ONSET-NG.EXERCISE.CONTINUE" | translate }}
                </button>
              } @else {
                <button
                  class="btn"
                  style="font-size: smaller"
                  (click)="onTestEnd()"
                  [hidden]="!readyCheckbox"
                  [disabled]="!readyCheckbox"
                  [style.background-color]="cTestButtonColor()">
                  {{ "GAST-ONSET-NG.EXERCISE.END_TEST" | translate }}
                </button>
              }
            </div>
            <div class="col-2"></div>
            @if (!mobileMode()) {
              <div style="margin-top: 8px">
                @if (timeLeft <= limitWhenToShowTime) {
                  {{ "GAST-ONSET-NG.EXERCISE.TIME_REMAINING" | translate }} {{ timeLeft }}
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Mobile keyboard -->
      @if (mobileMode()) {
        <div style="margin-top: 8px; position: absolute; bottom: 0" class="container-fluid mobile-keyboard">
          <div class="d-flex justify-content-center keyboard-row">
            <button
              #buttonVar
              class="mobile-keyboard-button"
              (touchstart)="assignCharacter('q', $event)"
              (touchend)="onTouchend($event)">
              {{ "q" }}
            </button>

            @for (character of FIRST_KEYBOARD_ROW; track character; let lastCharacter = $last) {
              <button
                class="mobile-keyboard-button"
                [class.mr-0]="lastCharacter"
                (touchstart)="assignCharacter(character, $event)"
                (touchend)="onTouchend($event)">
                {{ character }}
              </button>
            }
          </div>

          @for (keyboardRow of KEYBOARD_ROWS; track keyboardRow; let lastRow = $last) {
            <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px">
              @for (character of keyboardRow; track character; let lastCharacter = $last) {
                <button
                  class="mobile-keyboard-button"
                  [class.mr-0]="lastCharacter"
                  [ngStyle]="lastRow ? { 'max-width.px': buttonVar.offsetWidth } : {}"
                  (touchstart)="assignCharacter(character, $event)"
                  (touchend)="onTouchend($event)">
                  {{ character }}
                </button>
                @if (lastRow && lastCharacter) {
                  <button
                    [ngStyle]="{ 'max-width.px': buttonVar.offsetWidth * 2 }"
                    class="mobile-keyboard-button remove-button mr-0"
                    (touchstart)="removeLastCharacter($event)"
                    (touchend)="onTouchend($event)">
                    <i class="fas fa-backspace" style="pointer-events: none"></i>
                  </button>
                }
              }
            </div>
          }
          <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px">
            <div class="col-4" style="line-height: 1.15 !important"></div>
            <div class="col-4" style="padding-left: 0; padding-right: 0">
              <button
                class="mobile-keyboard-button"
                style="width: 33%; background-color: #50b4ae"
                (touchstart)="goToPreviousInput($event)">
                <i class="fas fa-caret-left"></i>
              </button>
              <button
                class="mobile-keyboard-button"
                style="width: 33%; background-color: #50b4ae"
                (touchstart)="goToNextInput($event)">
                <i class="fas fa-caret-right"></i>
              </button>
            </div>
            <div class="col-4"></div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- special character for non german keyboard -->
  @if (!mobileMode()) {
    <div class="d-flex justify-content-center" style="padding-top: 10px">
      <div
        class="alert text-center"
        style="width: 720px; line-height: 30px; padding: 0 15px"
        [style.background-color]="clozeTestStyleModel().specialCharacterListColor"
        [style.border]="'1px solid ' + clozeTestStyleModel().frameColor"
        [style.font-family]="clozeTestStyleModel().font"
        role="alert">
        <span [style.color]="clozeTestStyleModel()?.specialChcaracterTextColor">{{
          "GAST-ONSET-NG.EXERCISE.SPECIAL_CHAR_INFO" | translate
        }}</span>
        <span
          [tabindex]="0"
          class="badge badge-secondary"
          (keyup.enter)="assignCharacter('ä', $event)"
          (click)="assignCharacter('ä', $event)"
          [style.font-size]="'15px'"
          style="margin-right: 5px; cursor: pointer"
          >ä</span
        >
        <span
          [tabindex]="0"
          class="badge badge-secondary"
          (keyup.enter)="assignCharacter('ö', $event)"
          (click)="assignCharacter('ö', $event)"
          [style.font-size]="'15px'"
          style="margin-right: 5px; cursor: pointer"
          >ö</span
        >
        <span
          [tabindex]="0"
          class="badge badge-secondary"
          (keyup.enter)="assignCharacter('ü', $event)"
          (click)="assignCharacter('ü', $event)"
          [style.font-size]="'15px'"
          style="margin-right: 5px; cursor: pointer"
          >ü</span
        >
        <span
          [tabindex]="0"
          class="badge badge-secondary"
          (keyup.enter)="assignCharacter('ü', $event)"
          (click)="assignCharacter('ß', $event)"
          [style.font-size]="'15px'"
          style="margin-right: 5px; cursor: pointer"
          >ß</span
        >
      </div>
    </div>
  }
</div>
